export const IS_NULL_OR_UNDEFINED = (value: any): boolean => {
	return value === undefined || value === null;
};

export const IS_NOT_NULL_OR_UNDEFINED = (value: any): boolean => {
	return value !== undefined && value !== null;
};
